module.exports = __webpack_public_path__ + "static/img/inforbanner2.00b8f36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inforbanner2.jpg
// module id = Jb9R
// module chunks = 0